import React from "react";
import { useTable, usePagination } from "react-table";
import { Box } from "@mui/material";
import AddMoreColumnTH from "./AddMoreColumnTH";
import AddMoreRowTD from "./AddMoreRowTD";
import "./freeFrom.scss";
import EditableCell from "./EditableCell";
import FreeFormRowRejectAndReviewNew from "./FreeFormRowRejectAndReviewNew";
import ValidationButton from "./ValidationButton";
import Label from "../../Label/Label";

const FixedHeader = ({ data, page, role }) => {
  const ShowValue = ({ cellValues }) => {
    let value = "";
    if (
      role === "preProcessor" &&
      cellValues?.tagName &&
      cellValues?.pageNo >= 0
    ) {
      value = `${cellValues?.tagName} - ${parseInt(cellValues?.pageNo) + 1}`; // pageno starting from 0 to show +1 is added
    }
    if (role !== "preProcessor") {
      value = cellValues?.value;
    }
    return value;
  };

  return Object?.keys(page?.values)?.map((key, index) => (
    <td>
      <div className="free-form-td" rows="1">
        <ShowValue cellValues={data[key]} />
      </div>
    </td>
  ));
};

// Set our editable cell renderer as the default Cell renderer
const defaultColumn = {
  Cell: EditableCell,
};

// Be sure to pass our updateMyData and the skipPageReset option
function Table({
  columns,
  data,
  updateMyData,
  setCellToUpdateToState,
  skipPageReset,
  addColInBetween,
  deleteColumn,
  addRowsInBetween,
  deleteRow,
  updateDataUsingManuallyContextMenu,
  anyOperationPerformedOnEntirePage,
  showPagination,
  showContextMenu,
  isDisableOnChangeInput,
  isDisableOnBlur,
  role,
  rejectCell,
  deleteRejection,
  handleRowRejection,
  deleteRowRejection,
  markAsResolveByProcessor,
  reProcess,
  reValidate,
  isDataRejectedByProcessor,
  isDataRejectedByValidator,
  markAsResolveRejection,
  onClickValidate,
  clearMappings,
  entireBatchRejectedByPro,
  entireBatchRejectedByVali,
  reProcessEntireBatch,
  addLogsForMappingOnBlur,
  resestSelectedArea,
}) {
  // For this example, we're using pagination to illustrate how to stop
  // the current page from resetting when our data changes
  // Otherwise, nothing is different here.
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // use the skipPageReset option to disable page resetting temporarily
      autoResetPage: !skipPageReset,
      // updateMyData isn't part of the API, but
      // anything we put into these options will
      // automatically be available on the instance.
      // That way we can call this function from our
      // cell renderer!
      updateMyData,
      setCellToUpdateToState,
      updateDataUsingManuallyContextMenu,
      anyOperationPerformedOnEntirePage,
      showContextMenu,
      isDisableOnChangeInput,
      isDisableOnBlur,
      role,
      rejectCell,
      deleteRejection,
      handleRowRejection,
      deleteRowRejection,
      markAsResolveByProcessor,
      reProcess,
      reValidate,
      isDataRejectedByProcessor,
      isDataRejectedByValidator,
      markAsResolveRejection,
      clearMappings,
      entireBatchRejectedByPro,
      entireBatchRejectedByVali,
      reProcessEntireBatch,
      addLogsForMappingOnBlur,
      resestSelectedArea,
    },
    usePagination
  );

  // Render the UI for your table
  return (
    <>
      <Box
        className={
          role === "preProcessor" || role === "processor"
            ? "create-table-wrap-preProcessor"
            : "create-table-wrap-validator"
        }
      >
        <table stickyHeader className="create-table" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {/* Left Side First row (Alphabets) First cell #Empty cell */}
                <th></th>

                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps()}
                    className={
                      data[0][column.id]?.newColumn ? "new-column" : ""
                    }
                  >
                    <AddMoreColumnTH
                      column={column}
                      addColInBetween={addColInBetween}
                      deleteColumn={deleteColumn}
                      showColHeadersMenu={role !== "validator"}
                      role={role}
                    />
                  </th>
                ))}

                {role === "processor" && (
                  <>
                    <th className="rejection-processor-label">
                      {" "}
                      <Label text="Reject" padding="10px 4px">
                        {" "}
                      </Label>{" "}
                    </th>
                    {role === "processor" && isDataRejectedByValidator && (
                      <th className="rejection-processor-label">
                        {" "}
                        <Label text="Rejected By Validator" padding="0px">
                          {" "}
                        </Label>
                      </th>
                    )}
                  </>
                )}

                {role === "preProcessor" && isDataRejectedByProcessor && (
                  <th className="rejection-pre-processor-label">
                    {" "}
                    <Label text="Rejected By Processor" padding="0px">
                      {" "}
                    </Label>{" "}
                  </th>
                )}
                {role === "validator" && (
                  <>
                    <th className="rejection-validator-label">
                      <Label text="validate" padding="10px 4px">
                        {" "}
                      </Label>
                    </th>
                    <th className="rejection-validator-label">
                      <Label text="Reject" padding="10px 4px">
                        {" "}
                      </Label>
                    </th>
                  </>
                )}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {/* Sticky Header Row From 2nd Page */}
            {pageIndex > 0 ? (
              <tr hover className="first-empty-cell">
                {/* Sticky deta 1st row 1st empty cell for pages onword 1st page*/}
                <td></td> {/* left side first empty cell */}
                {data[0] && page[0] && (
                  <FixedHeader data={data[0]} page={page[0]} role={role} />
                )}
              </tr>
            ) : (
              ""
            )}

            {page?.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  {...(i === 0 && pageIndex === 0
                    ? {
                        style: {
                          position: "sticky",
                          top: 43,
                          backgroundColor:
                            i === 0 && pageIndex === 0
                              ? "rgb(248 249 250)"
                              : "white",
                          zIndex: 4,
                        },
                      }
                    : "")}
                >
                  <td>
                    <AddMoreRowTD
                      rowId={row?.id}
                      addRowsInBetween={addRowsInBetween}
                      deleteRow={deleteRow}
                      showRowHeadersMenu={role !== "validator"}
                      role={role}
                    />
                  </td>

                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}

                  {/* last td from tr for rejection row wise */}

                  {role === "processor" && (
                    <td className="rejectCheckbox">
                      <FreeFormRowRejectAndReviewNew
                        handleRowRejection={handleRowRejection}
                        parameterData={row?.original}
                        deleteRowRejection={deleteRowRejection}
                        role={role}
                        markAsResolveRejection={markAsResolveRejection}
                        parameterIndex={row?.id}
                        isShowClearButton={false}
                        heading={"Do you want to reject the row?"}
                      />
                    </td>
                  )}
                  {/* 1st Checkbox in Pre processor after rejected by processor */}
                  {role === "preProcessor" && isDataRejectedByProcessor && (
                    <td className="rejectCheckbox">
                      <FreeFormRowRejectAndReviewNew
                        handleRowRejection={handleRowRejection}
                        parameterData={row?.original}
                        deleteRowRejection={deleteRowRejection}
                        role={role}
                        isReadOnly={true}
                        isDataRejectedByProcessor
                        markAsResolveRejection={markAsResolveRejection}
                        parameterIndex={row?.id}
                        isShowClearButton={false}
                        heading={"Row Rejection Remark."}
                      />
                    </td>
                  )}

                  {/* 2nd Checkbox in processor after rejected by vali */}
                  {role === "processor" && isDataRejectedByValidator && (
                    <td className="rejectCheckbox">
                      <FreeFormRowRejectAndReviewNew
                        handleRowRejection={handleRowRejection}
                        deleteRowRejection={deleteRowRejection}
                        role={role}
                        isReadOnly={true}
                        isDataRejectedByValidator
                        markAsResolveRejection={markAsResolveRejection}
                        parameterData={row?.original}
                        parameterIndex={row?.id}
                        isShowClearButton={false}
                        heading={"Row rejection remark."}
                      />
                    </td>
                  )}

                  {role === "processor" &&
                    row?.original?.processorRowRejection?.isResolved && (
                      <td className="rejectCheckbox">
                        <FreeFormRowRejectAndReviewNew
                          parameterData={row?.original}
                          role={role}
                          parameterIndex={i}
                          heading={"View Remark"}
                          disableFooterBtns={true}
                          icon="view"
                        />
                      </td>
                    )}

                  {/* Validation Button */}
                  {role === "validator" && (
                    <>
                      <td className="border-remove">
                        <ValidationButton
                          onClickValidate={onClickValidate}
                          parameterData={row?.original}
                          parameterIndex={row?.id}
                        />
                      </td>
                      <td className="rejectCheckbox">
                        <FreeFormRowRejectAndReviewNew
                          handleRowRejection={handleRowRejection}
                          parameterData={row?.original}
                          deleteRowRejection={deleteRowRejection}
                          role={role}
                          markAsResolveRejection={markAsResolveRejection}
                          parameterIndex={row?.id}
                          isShowClearButton={false}
                          heading={"Do you want to reject the row?"}
                        />
                      </td>

                      {role === "validator" &&
                        row?.original?.validatorRowRejection?.isResolved && (
                          <td className="rejectCheckbox">
                            <FreeFormRowRejectAndReviewNew
                              parameterData={row?.original}
                              role={role}
                              parameterIndex={i}
                              heading={"View Remark"}
                              disableFooterBtns={true}
                              icon="view"
                            />
                          </td>
                        )}
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
      {showPagination && (
        <div className="pagination">
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {"<<"}
          </button>{" "}
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {"<"}
          </button>{" "}
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {">"}
          </button>{" "}
          <button
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </button>{" "}
          <span>
            Page{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
          <span>
            | Go to page:{" "}
            <input
              className="gotoPage"
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
            />
          </span>{" "}
          <lable>Rows per page </lable>
          <select
            className="showsNoOfPage"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 20, 30, 40, 50, 75, 100, 150, 200].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
      )}
    </>
  );
}

Table.defaultProps = {
  showContextMenu: true,
  showPagination: true,
  isDisableOnChangeInput: false,
  isDisableOnBlur: false,
};

export default Table;
